import { AlignTypes } from "@monorepo-web/components-library";
export const getLayouts = (dadosMesaMesAgrupados, theme) => ({
    'default': [
        {
            id: 'ano',
            label: '',
            rowSpan: Object.keys(dadosMesaMesAgrupados).length <= 0
                ? 0
                : dadosMesaMesAgrupados[Object.keys(dadosMesaMesAgrupados)[0]].length,
            bgColor: theme.sideBoxColor,
            color: 'white',
            padding: '4px',
            align: AlignTypes.center,
            borderLeftRadius: '5px',
            freeze: true,
        },
        {
            id: 'ativo',
            label: 'Ativo',
            freeze: true,
            leftOnFreeze: 40,
            noBreak: true,
        },
        { id: 'Jan', label: 'Jan', align: AlignTypes.right },
        { id: 'Fev', label: 'Fev', align: AlignTypes.right },
        { id: 'Mar', label: 'Mar', align: AlignTypes.right },
        { id: 'Abr', label: 'Abr', align: AlignTypes.right },
        { id: 'Mai', label: 'Mai', align: AlignTypes.right },
        { id: 'Jun', label: 'Jun', align: AlignTypes.right },
        { id: 'Jul', label: 'Jul', align: AlignTypes.right },
        { id: 'Ago', label: 'Ago', align: AlignTypes.right },
        { id: 'Set', label: 'Set', align: AlignTypes.right },
        { id: 'Out', label: 'Out', align: AlignTypes.right },
        { id: 'Nov', label: 'Nov', align: AlignTypes.right },
        { id: 'Dez', label: 'Dez', align: AlignTypes.right },
        { id: 'Ano', label: 'Ano', align: AlignTypes.right },
        { id: 'Acum', label: 'Acum', align: AlignTypes.right },
    ]
});
